import React from 'react'
import type {VesselContactEntry} from '../core/vesselContactFields'

type Props = {
  addLabel: string
  entries: VesselContactEntry[]
  error?: string
  idPrefix: string
  inputType: 'text' | 'email'
  label: string
  onAdd: () => void
  onChange: (index: number, value: string) => void
  onMakePrimary: (index: number) => void
  onRemove: (index: number) => void
  placeholder?: string
}

const VesselContactListField: React.FC<Props> = ({
  addLabel,
  entries,
  error,
  idPrefix,
  inputType,
  label,
  onAdd,
  onChange,
  onMakePrimary,
  onRemove,
  placeholder,
}) => (
  <div>
    <label className='modal_label'>{label}</label>
    <div className='d-flex flex-column gap-2'>
      {entries.map((entry, index) => (
        <div className='d-flex gap-2 align-items-start' key={`${idPrefix}-${index}`}>
          <input
            aria-label={`${label} ${index + 1}`}
            className='form-control'
            id={`${idPrefix}-${index}`}
            placeholder={placeholder}
            type={inputType}
            value={entry.value}
            onChange={(event) => onChange(index, event.target.value)}
          />
          <button
            className={`btn btn-sm ${entry.primary ? 'btn-primary' : 'btn-light-primary'}`}
            disabled={entry.value.trim() === ''}
            type='button'
            onClick={() => onMakePrimary(index)}
          >
            {entry.primary ? 'Primary' : 'Make Primary'}
          </button>
          <button
            aria-label={`Remove ${label} ${index + 1}`}
            className='btn btn-sm btn-light-danger'
            disabled={entries.length === 1}
            type='button'
            onClick={() => onRemove(index)}
          >
            Remove
          </button>
        </div>
      ))}
    </div>
    <button className='btn btn-sm btn-light mt-2' type='button' onClick={onAdd}>
      {addLabel}
    </button>
    {error && <small className='text-danger d-block mt-1'>{error}</small>}
  </div>
)

export default VesselContactListField
